import React from "react";
import { Table, Card } from "react-bootstrap";
import ImageGallery from "react-image-gallery";

import classes from "./PreviewPage.module.css";

const PreviewPage = (props) => {
  let post = null,
    uploadedViedo = null,
    videoUrl = null,
    apparels = null,
    postELe = null,
    service = false,
    accessory = false;
  const serviceTypes = ["car_service", "motor_service", "commercial_service"];
  const accessoriesTypes = [
    "car_parts_accessory",
    "motor_parts_accessory",
    "commercial_parts_accessory",
  ];
  if (props.post) {
    post = props.post.data;
    service = serviceTypes.includes(post.vehicle_type);
    accessory = accessoriesTypes.includes(post.vehicle_type);
    apparels = post.vehicle_type === "all_apparels_merchandise";
    const images = [];
    post.media.forEach((img) => {
      const item = {
        original: img.url,
        thumbnail: img.url,
        originalHeight: 400,
        thumbnailHeight: 60,
      };
      if ((img.name === "video")) {
        item.renderItem = () => (
          <video src={img.url} autoPlay controls height="400px"/>
        );
        item.thumbnail = post.media[0].url;
      }

      images.push(item);
    });
    postELe = (
      <div className={classes.PostElement}>
        <h1 className="mt-5">Preview post #{post.id}</h1>
        <ImageGallery
          items={images.sort((a) => {
            if ((a.name === "video")) return 1;
            else return -1;
          })}
          showPlayButton={false}
        />
        <Card className="my-3">
          <Card.Header>
            <h4>Seller Pitch</h4>
          </Card.Header>
          <Card.Body>
            <p style={{ whiteSpace: "pre-wrap" }}>{post.seller_pitch}</p>
          </Card.Body>
        </Card>
        <Table striped bordered>
          <tbody>
            {(props.service || service) && (
              <>
                <tr>
                  <td colSpan={2}>
                    <h4>Service working hours</h4>
                  </td>
                </tr>
                {post.opening_hours.map((day) => {
                  return (
                    <tr key={day.day_name}>
                      <td>{day.day_name}</td>
                      <td>
                        {day.opening_time} - {day.closing_time}
                      </td>
                    </tr>
                  );
                })}
              </>
            )}
            <tr>
              <td colSpan={2}>
                <h4>Key features</h4>
              </td>
            </tr>
            {post.category && (
              <tr>
                <td>Category</td>
                <td>{post.category ? post.category.name : null}</td>
              </tr>
            )}
            {post.price && (
              <tr>
                <td>Price</td>
                <td>{post.price}</td>
              </tr>
            )}
            {post.condition && (
              <tr>
                <td>Condition</td>
                <td>{post.condition}</td>
              </tr>
            )}
            {post.body_type && (
              <tr>
                <td>Body Type</td>
                <td>{post.body_type}</td>
              </tr>
            )}
            {post.body_type && (
              <tr>
                <td>Body Type</td>
                <td>{post.body_type}</td>
              </tr>
            )}
            {post.transmission && (
              <tr>
                <td>Transmition</td>
                <td>{post.transmission}</td>
              </tr>
            )}
            {post.mileage && (
              <tr>
                <td>mileage </td>
                <td>{post.mileage}</td>
              </tr>
            )}
            {post.driven_wheel && (
              <tr>
                <td>Driven Wheel </td>
                <td>{post.driven_wheel}</td>
              </tr>
            )}
            {post.hourly_price && (
              <tr>
                <td>Per Hour </td>
                <td>{post.hourly_price}</td>
              </tr>
            )}
            {post.daily_price && (
              <tr>
                <td>Per Day </td>
                <td>{post.daily_price}</td>
              </tr>
            )}
            {post.weekly_price && (
              <tr>
                <td>Per Week </td>
                <td>{post.weekly_price}</td>
              </tr>
            )}
            {post.monthly_price && (
              <tr>
                <td>Per Mounth </td>
                <td>{post.monthly_price}</td>
              </tr>
            )}
            {post.year_of_manufacture && (
              <tr>
                <td>Year </td>
                <td>{post.year_of_manufacture}</td>
              </tr>
            )}
            {post.fuel_type && (
              <tr>
                <td>Fuel Type </td>
                <td>{post.fuel_type}</td>
              </tr>
            )}
            {post.vehicle_make && (
              <tr>
                <td>Make </td>
                <td>{post.vehicle_make ? post.vehicle_make.name : null}</td>
              </tr>
            )}
            {post.vehicle_model && (
              <tr>
                <td>Model </td>
                <td>{post.vehicle_model ? post.vehicle_model.name : null}</td>
              </tr>
            )}
            {post.vehicle_variant && (
              <tr>
                <td>Variant </td>
                <td>
                  {post.vehicle_variant ? post.vehicle_variant.name : null}
                </td>
              </tr>
            )}
            {accessory && (
              <>
                <tr>
                  <td>manufacturer part number</td>
                  <td>{post.manufacturer_part_number}</td>
                </tr>
                <tr>
                  <td>compatible vehicle</td>
                  <td>{post.compatible_vehicle}</td>
                </tr>
                <tr>
                  <td>product brand</td>
                  <td>{post.product_brand}</td>
                </tr>
              </>
            )}
            {apparels && (
              <>
                <tr>
                  <td>Gender</td>
                  <td>{post.gender ? post.gender.name : null}</td>
                </tr>
                <tr>
                  <td>Delivery Option</td>
                  <td>
                    {post.delivery_option ? post.delivery_option.name : null}
                  </td>
                </tr>
                <tr>
                  <td>Size</td>
                  <td>{post.size}</td>
                </tr>
              </>
            )}
            <tr>
              <td>Country</td>
              <td>{post.country ? post.country.name : null}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{post.state ? post.state.name : null}</td>
            </tr>
            <tr>
              <td>Area</td>
              <td>{post.area ? post.area.name : null}</td>
            </tr>
          </tbody>
        </Table>

        <img
          className={classes.googleImage + " my-5"}
          src={`https://maps.googleapis.com/maps/api/staticmap?center=${
            post.lat ? post.lat : 3.130139984630583
          },${
            post.lng ? post.lng : 101.71781613714228
          }&zoom=16&size=640x640&maptype=roadmap&markers=color:red%7Clabel:%7C${
            post.lat ? post.lat : 3.130139984630583
          },${post.lng ? post.lng : 101.71781613714228}&key=${
            process.env.REACT_APP_GOOGLE_API_KEY
          }`}
          alt="map"
        />
      </div>
    );
  }
  return (
    <div
      style={{
        opacity: props.post ? 1 : 0,
        transition: "all 0.6s ease-in",
      }}
      className={classes.Container}
    >
      {postELe}
      {!props.noEdit && (
        <div className={classes.BtnGroup}>
          <button
            className={classes.Btn}
            type="button"
            onClick={() => {
              props.submitPost();
            }}
          >
            Submit
          </button>
          <button
            className={`${classes.Btn} ${classes.BtnEdit}`}
            type="button"
            onClick={() => {
              props.editPost();
            }}
          >
            Edit
          </button>
        </div>
      )}
    </div>
  );
};

export default PreviewPage;
